import { ClientConfig } from '../../config/ClientConfig'
import { HttpService } from '../../services/http-service'
import {FeatureToggleService} from "../../services/FeatureToggleService";

export enum SddStatus {
	REQUIRED = 'REQUIRED',
	COLLECTED = 'COLLECTED',
	ACCEPTED = 'ACCEPTED',
}

export interface SddStatusResponse {
	status: SddStatus;
}

export interface ResidentialAddress {
	unit?: string;
	streetAddressLine1?: string;
	streetAddressLine2?: string;
	zipCode?: string;
	state?: string;
	city?: string;
	country?: string;
}

export function fetchSddStatus(): Promise<SddStatusResponse> {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/sdd/risk-assessment/status`
	return HttpService.get<SddStatusResponse>(url, { authenticate: true })
}

export function postSddForm(personalInfo: PersonalInfo): Promise<{}> {
	const url = FeatureToggleService.kycFirstPurchaseFeature.isNewSddSubmissionEndpointEnabled()
        ? `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/sdd/risk-assessment/collect`
        : `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/sdd/submit`
	return HttpService.post(url, { personalInfo }, { authenticate: true })
}

export function fetchPaymentsSessionForIdentityAndAddress(): Promise<string> {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/document-verification/account/session/create`
	return HttpService.post<string>(url, {sessionId: uniqueSessionId}, {authenticate: true})
}

export function fetchPaymentsSessionForAddress(): Promise<string> {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/document-verification/address/session/create`
	return HttpService.post<string>(url, {sessionId: uniqueSessionId}, {authenticate: true})
}

export const performLoginRiskAssessment = (rmpProfilingBundle: string) : Promise<string> => {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/customer/risk-assessment/login`
	return HttpService.post(url, { rawProfilingBundle: rmpProfilingBundle }, { authenticate: true })
}

export const acceptJumioTermsAndConditions = (userId: string): Promise<void> => {
    const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/customer/${userId}/jumio`
    return HttpService.post(url, {}, { authenticate: true })
}

export function fetchResidentialAddress(userId: string): Promise<ResidentialAddress> {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/customer/${userId}/residential-address`
	return HttpService.get<ResidentialAddress>(url, { authenticate: true })
}

export async function fetchResidentialState(userId: string): Promise<string> {
	const { state } = await fetchResidentialAddress(userId)
	return state ?? ''
}

export function fetchGeoComplyToken(): Promise<string> {
	const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/geo-comply/token`
	return HttpService.get<{ token: string }>(url, { authenticate: true }).then(r => {
		const token = r?.token
		if (typeof token !== 'string' || !token.trim()) {
			return Promise.reject(new Error('GeoComply token missing or invalid'))
		}
		return token
	})
}
